<template>
  <div class="ai_task_box" v-loading.fullscreen.lock="showLoading">
    <div class="box_operation">
      <div class="btn_box">
        <el-button type="primary" @click="getTaskList">刷新</el-button>
      </div>
      <!-- 过滤选项 -->
      <div class="filter_box">
        <div class="filter_item">
          <label>用户ID：</label>
          <el-input v-model="filterOpenId" placeholder="输入用户ID" clearable @keyup.enter.native="handleFilterChange"></el-input>
        </div>
        <div class="filter_item">
          <label>提示词：</label>
          <el-input v-model="filterPrompt" placeholder="输入提示词" clearable @keyup.enter.native="handleFilterChange"></el-input>
        </div>
        <div class="filter_item">
          <label>功能名字：</label>
          <el-select v-model="filterFuncName" placeholder="选择功能" clearable @change="handleFilterChange">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="func in funcNameList" :key="func" :label="func" :value="func"></el-option>
          </el-select>
        </div>
        <div class="filter_item">
          <label>状态：</label>
          <el-select v-model="filterStatus" placeholder="选择状态" clearable @change="handleFilterChange">
            <el-option label="全部" value=""></el-option>
            <el-option label="成功" value="成功"></el-option>
            <el-option label="失败" value="失败"></el-option>
            <el-option label="处理中" value="处理中"></el-option>
          </el-select>
        </div>
        <div class="filter_item">
          <label>时间范围：</label>
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="dateRangePickerOptions"
            @change="handleFilterChange">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="data_box">
      <el-table
        class="table"
        border
        :data="taskList"
        style="width: 100%"
        @sort-change="sortChange">
        <el-table-column 
          align="center" 
          prop="id" 
          label="ID" 
          width="70" 
          sortable="custom" />
        <el-table-column 
          align="center" 
          prop="openId" 
          label="用户ID" 
          width="90" 
          sortable="custom" />
        <el-table-column 
          align="center" 
          prop="createTime" 
          label="时间" 
          width="90" 
          sortable="custom">
          <template slot-scope="scope">
            <div class="time-display">
              <div class="date-line">{{ formatDate(scope.row.createTime) }}</div>
              <div class="time-line">{{ formatTime(scope.row.createTime) }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column 
          align="center" 
          prop="funcName" 
          label="功能名字" 
          width="80" 
          sortable="custom" />
        <el-table-column align="center" label="提示词" min-width="220">
          <template slot-scope="scope">
            <div class="prompt_text">
              <div class="original-prompt">{{ scope.row.prompt }}</div>
              <div v-if="scope.row.optedPrompt" class="optimized-prompt">
                <div class="separator">----优化过的提示词----</div>
                <div class="optimized-content">{{ scope.row.optedPrompt }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="原始图片" width="380">
          <template slot-scope="scope">
            <template v-if="scope.row.originImage">
              <a :href="getRealUrl(scope.row.originImage)" target="_blank">
                <img :src="getRealUrl(scope.row.originImage)" class="preview_image" @error="onImgError" />
              </a>
            </template>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="风格图片" width="380">
          <template slot-scope="scope">
            <template v-if="scope.row.styleImage">
              <a :href="getRealUrl(scope.row.styleImage)" target="_blank">
                <img :src="getRealUrl(scope.row.styleImage)" class="preview_image" @error="onImgError" />
              </a>
            </template>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="结果图片" width="380">
          <template slot-scope="scope">
            <template v-if="scope.row.resultImage">
              <a :href="getRealUrl(scope.row.resultImage)" target="_blank">
                <img :src="getRealUrl(scope.row.resultImage)" class="preview_image" @error="onImgError" />
              </a>
            </template>
            <span v-else>暂无</span>
          </template>
        </el-table-column>
        <el-table-column 
          align="center" 
          prop="statusMsg" 
          label="状态信息" 
          min-width="200" 
          show-overflow-tooltip 
          sortable="custom" />
      </el-table>
      <div class="page">
        <el-pagination
          background
          :page-size="pageCount"
          :current-page="pageNo"
          layout="prev, pager, next"
          :page-count="pageSum"
          @current-change="changePage" />
      </div>
    </div>
  </div>
  
</template>

<script>
import {dateRangePickerOptions} from '@/base_js/dateRangePickerOptions';

export default {
  name: 'aiDrawTaskManager',
  data () {
    return {
      showLoading: false,
      taskList: [],
      pageNo: 1,
      pageCount: 200,
      pageSum: 1,
      // 排序相关
      sortStatus: {
        id: null,
        createTime: null,
        funcName: null,
        statusMsg: null
      },
      sortField: '',
      sortOrder: '',
      // 过滤相关
      filterOpenId: '',
      filterPrompt: '',
      filterFuncName: '',
      filterStatus: '',
      dateRange: [],
      dateRangePickerOptions,
      funcNameList: [] // 功能名字列表，用于过滤选项
    }
  },
  mounted () {
    this.getAllFuncNames() // 先获取所有功能名称
    this.getTaskList()
  },
  methods: {
    /**
     * 格式化日期部分
     */
    formatDate(dateTime) {
      if (!dateTime) return ''
      const date = new Date(dateTime)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    /**
     * 格式化时间部分
     */
    formatTime(dateTime) {
      if (!dateTime) return ''
      const date = new Date(dateTime)
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${hours}:${minutes}:${seconds}`
    },
    getRealUrl (url) {
      if (!url) return ''
      // 已是绝对地址则直接返回
      if (/^https?:\/\//i.test(url)) return url
      // 兼容存相对路径的情况
      return 'http://file.baozouptu.intelimeditor.com/' + url
    },
    onImgError (e) {
      // 图片异常时隐藏图片，避免破图
      if (e && e.target) e.target.style.display = 'none'
    },
    /**
     * 排序规则改变
     */
    sortChange: function ({column, prop, order}) {
      console.log(prop + " - " + order + " - " + this.sortStatus[prop])
      if (!this.sortStatus[prop]) {
        // 如果是第一次点击，设置为降序
        this.sortStatus[prop] = 'descending';
        column.order = 'descending';
      } else if (this.sortStatus[prop] === 'descending') {
        // 否则，根据当前排序状态更新
        this.sortStatus[prop] = 'ascending';
        column.order = 'ascending';
      } else {
        // 否则，根据当前排序状态更新
        this.sortStatus[prop] = 'descending';
        column.order = 'descending';
      }

      // 更新其他列的排序状态
      for (const key in this.sortStatus) {
        if (key !== prop) {
          this.sortStatus[key] = null;
        }
      }

      this.sortField = prop;
      this.sortOrder = this.sortStatus[prop];
      this.getTaskList();
    },
    /**
     * 过滤条件改变
     */
    handleFilterChange() {
      this.pageNo = 1; // 重置到第一页
      this.getTaskList();
    },
    /**
     * 获取所有功能名称列表（用于过滤选项）
     */
    getAllFuncNames() {
      const params = new URLSearchParams()
      params.append('getAllFuncNames', 1) // 添加标识获取所有功能名称
      
      this.$request.post('/aiDraw/getTaskList', params)
        .then((data) => {
          if (data.status === 200 && data.data.records) {
            // 从所有数据中提取功能名称
            const funcNames = [...new Set(data.data.records.map(task => task.funcName).filter(name => name))];
            this.funcNameList = funcNames;
          }
        }).catch(() => {
          // 如果获取失败，使用当前数据提取
          console.log('获取所有功能名称失败，使用当前数据')
        })
    },
    /**
     * 提取功能名字列表（保留作为备用方案）
     */
    extractFuncNames(taskList) {
      // 只有在funcNameList为空时才从当前数据提取
      if (this.funcNameList.length === 0) {
        const funcNames = [...new Set(taskList.map(task => task.funcName).filter(name => name))];
        this.funcNameList = funcNames;
      }
    },
    getTaskList () {
      this.showLoading = true
      const params = new URLSearchParams()
      params.append('isPage', 1)
      params.append('pageNo', this.pageNo)
      params.append('pageCount', this.pageCount)
      
      // 添加排序参数
      if (this.sortField) {
        params.append('sortField', this.sortField)
        params.append('sortOrder', this.sortOrder === 'ascending' ? 'asc' : 'desc')
      }
      
      // 添加过滤参数
      if (this.filterOpenId) {
        params.append('openId', this.filterOpenId)
      }
      if (this.filterPrompt) {
        params.append('prompt', this.filterPrompt)
      }
      if (this.filterFuncName) {
        params.append('funcName', this.filterFuncName)
      }
      if (this.filterStatus) {
        params.append('status', this.filterStatus)
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.append('startDate', this.dateRange[0])
        params.append('endDate', this.dateRange[1])
      }
      
      this.$request.post('/aiDraw/getTaskList', params)
        .then((data) => {
          this.showLoading = false
          if (data.status === 200) {
            this.taskList = data.data.records || []
            this.pageSum = data.data.pages || 1
            
            // 调试：打印第一条数据的结构，查看是否包含optedPrompt字段
            if (this.taskList.length > 0) {
              console.log('第一条任务数据结构:', this.taskList[0])
              console.log('optedPrompt字段值:', this.taskList[0].optedPrompt)
            }
            
            // 提取功能名字列表用于过滤
            this.extractFuncNames(this.taskList)
          } else {
            this.showMsg(data.message || '请求失败')
          }
        }).catch(() => {
          this.showLoading = false
          this.showMsg('网络错误')
        })
    },
    changePage (page) {
      this.pageNo = page
      this.getTaskList()
    },
    showMsg (title) {
      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
  }
}
</script>

<style scoped>
.ai_task_box .table {
  width: 100%;
}
.ai_task_box .preview_image {
  width: 360px;
  height: auto;
}
.ai_task_box .prompt_text {
  white-space: pre-wrap;
  word-break: break-word;
  text-align: left;
  padding: 8px;
  line-height: 1.4;
}
.page {
  margin-top: 16px;
  text-align: center;
}

/* 过滤选项样式 */
.filter_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;
  padding: 10px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.filter_item {
  display: flex;
  align-items: center;
  margin-right: 20px;
  margin-bottom: 10px;
}

.filter_item label {
  margin-right: 8px;
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

.filter_item .el-select,
.filter_item .el-input,
.filter_item .el-date-editor {
  width: 180px;
}

.filter_item .el-input /deep/ input {
  height: 32px;
}

/* 时间显示样式 */
.time-display {
  line-height: 1.2;
}

.date-line {
  font-size: 12px;
  color: #333;
  margin-bottom: 2px;
}

.time-line {
  font-size: 12px;
  color: #666;
}

/* 合并提示词显示样式 */
.original-prompt {
  margin-bottom: 8px;
}

.optimized-prompt {
  margin-top: 8px;
}

.separator {
  font-size: 11px;
  color: #666;
  text-align: center;
  margin: 15px 0;
  font-style: italic;
  border-top: 2px solid #ddd;
  border-bottom: 1px solid #eee;
  padding: 10px 0;
  background-color: #f9f9f9;
  font-weight: bold;
}

.optimized-content {
  color: #666;
}
</style>

